import { useEffect, useState } from "react";
import type { PendingSubmit } from "@/lib/types";

/**
 * Live countdown driven by pendingSubmit.expiresAt (server timestamp).
 * Source of truth for "is it too late to cancel" remains the server.
 */
export const useCountdown = (pendingSubmit: PendingSubmit | null): { secondsLeft: number; expired: boolean } => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!pendingSubmit) return;
    let raf = 0;
    const tick = () => {
      setNow(Date.now());
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [pendingSubmit?.id]);

  if (!pendingSubmit) return { secondsLeft: 0, expired: false };

  const ms = Math.max(0, pendingSubmit.expiresAt - now);
  return {
    secondsLeft: Math.ceil(ms / 1000),
    expired: ms <= 0,
  };
};
